import { render, staticRenderFns } from "./AddResourceDialog.vue?vue&type=template&id=630e14a2"
import script from "./AddResourceDialog.vue?vue&type=script&lang=js"
export * from "./AddResourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports